import { MealType, PreparationNote } from '@akin-home/amplify';
import { notNull } from '@akin-home/arrays';
import { v4 as uuid } from 'uuid';
import { budget_rating_labels } from '../data/budget_rating_labels';
import { health_rating_labels } from '../data/health_rating_labels';
import {
  BudgetRatingID,
  HealthRatingID,
  Ingredient,
  MealPlanPreferences,
  PrepNote,
  PrepNoteIcon,
  Recipe,
  RecipeIngredient,
} from '../types';

export * from './filterRecipes';
export * from './getRecipeIngredientText';

/**
 * Creates a Recipe
 */
export const createRecipe = (input?: Partial<Recipe>): Recipe => ({
  id: uuid(),
  name: '',
  prepNotes: [],
  ingredients: [],
  utensils: [],
  allergyIDs: [],
  mealTypes: [],
  ...input,
});

/**
 * Creates an ingredient
 */
export const createIngredient = (input?: Partial<Ingredient>): Ingredient => ({
  id: uuid(),
  quantity: '1',
  unitOfMeasure: 'unit',
  name: '',
  category: '',
  pantryItem: false,
  ...input,
});

export const createRecipeIngredient = (
  input?: Partial<RecipeIngredient>
): RecipeIngredient => ({
  id: uuid(),
  name: '',
  quantity: '',
  unitOfMeasure: '',
  pantryItem: false,
  ...input,
});

export const createPrepNote = (input?: Partial<PrepNote>): PrepNote => ({
  id: input?.id || uuid(),
  description: '',
  title: '',
  ...input,
});

export const preparationNoteGraphqlToModel = (
  preparation_notes: PreparationNote[]
): PrepNote[] =>
  preparation_notes.map((note) => ({
    id: notNull(note.id) || '',
    title: notNull(note.title) || '',
    description: notNull(note.description) || '',
    icon: notNull(note.icon) as PrepNoteIcon | undefined,
  }));

export const getHealthRatingLabel = (health_rating_id: HealthRatingID) =>
  health_rating_labels[health_rating_id];

export const getHealthRatingOptions = (): {
  value: HealthRatingID;
  label: string;
}[] => [
  { value: 1, label: getHealthRatingLabel(1) },
  { value: 2, label: getHealthRatingLabel(2) },
  { value: 3, label: getHealthRatingLabel(3) },
];

export const getBudgetRatingLabel = (budget_rating_id: BudgetRatingID) =>
  budget_rating_labels[budget_rating_id];

export const getBudgetRatingOptions = (): {
  value: BudgetRatingID;
  label: string;
}[] => [
  { value: 1, label: getBudgetRatingLabel(1) },
  { value: 2, label: getBudgetRatingLabel(2) },
  { value: 3, label: getBudgetRatingLabel(3) },
  { value: 4, label: getBudgetRatingLabel(4) },
  { value: 5, label: getBudgetRatingLabel(5) },
];

export const getMealTypes = (): MealType[] => Object.values(MealType);

export const checkMealTypesToPlan = (preferences: MealPlanPreferences) => {
  return {
    [MealType.Breakfast]: preferences.meals_to_plan?.includes(
      MealType.Breakfast
    ),
    [MealType.Lunch]: preferences.meals_to_plan?.includes(MealType.Lunch),
    [MealType.Dinner]: preferences.meals_to_plan?.includes(MealType.Dinner),
    [MealType.Snack]: preferences.meals_to_plan?.includes(MealType.Snack),
  };
};
